import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import styles from '../brouillons/brouillons.module.css'; 
import { auth, db } from '../../firebase/firebase'; 
import { collection, query, where, getDocs } from 'firebase/firestore';

import HeaderBlack from '../../components/header/headerBlack/headerBlack';
import StatusCard from '../../components/statusCard/statusCard';
import PatientsTable from '../../components/patientsTable/patientsTable';
import usePatientSearch from '../../hooks/usePatientSearch';
import SearchInput from '../../components/search/SearchInput';

const Enproduction = () => {
  const [userName, setUserName] = useState('');
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
   // Handle patient selection
  const handlePatientClick = (patient) => {
  navigate(`/dossier`, { state: { patient } });
  };
  // Fetch user data using Firestore query
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const user = auth.currentUser;
        
        if (user) {
          /*console.log("Current user:", user);*/
          // Get the user's email and convert to lowercase for comparison
          const userEmail = user.email.toLowerCase();
          
          // Try to find the user with exact email match first
          const medecinsRef = collection(db, 'medecins'); 
          const q = query(medecinsRef, where('email', '==', user.email)); 
          let querySnapshot = await getDocs(q);
          
          // If no match, try with lowercase email
          if (querySnapshot.empty) {
            /*console.log("Trying case-insensitive email match");*/
            // Get all medecins and filter manually since Firestore doesn't support case-insensitive queries
            const allMedecinsQuery = query(medecinsRef);
            const allMedecinsSnapshot = await getDocs(allMedecinsQuery);
            
            // Find a document with case-insensitive email match
            const matchingDocs = allMedecinsSnapshot.docs.filter(doc => {
              const docEmail = doc.data().email;
              return docEmail && docEmail.toLowerCase() === userEmail;
            });
            
            if (matchingDocs.length > 0) {
              const userData = matchingDocs[0].data();
              /*console.log("Found user with case-insensitive email match:", userData);*/
              setUserName(userData.name || '');
            } else {
              /*console.log("User not found in medecins collection even with case-insensitive match");*/
              setUserName(user.displayName || 'Utilisateur');
            }
          } else {
            const userData = querySnapshot.docs[0].data();
            /*console.log("User data retrieved:", userData);*/
            setUserName(userData.name || '');
          }
        } else {
          /*console.log("No current user found");*/
        }
      } catch (error) {
        /*console.error('Error fetching user data:', error);*/
      } finally {
        setLoading(false);
      }
    };

    const authListener = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        fetchUserData();
      } else {
        setLoading(false);
        navigate('/login');
      }
    });
    
    return () => authListener();
  }, [navigate]);


  // Fetch patients data
  useEffect(() => {
    const fetchPatients = async () => {
      const user = auth.currentUser;
      if (!user) return;

      try {
        const patientsRef = collection(db, 'patients');
        const q = query(
          patientsRef,
          where('status', '==', 3),
          where('userId', '==', user.uid)
        );
        const querySnapshot = await getDocs(q);
        
        const patientsData = querySnapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .filter(patient => patient.archived !== 1); // Filter out archived patients
        
        setPatients(patientsData);
      } catch (error) {
        /*console.error('Error fetching patients:', error);*/
      }
    };

    fetchPatients();
  }, []);

  const { searchTerm, setSearchTerm, filteredPatients } = usePatientSearch(patients, ['name', 'surname']);

  return (
    <div>
      <HeaderBlack/>
      <main>
        <StatusCard/>
        <nav className={styles.tabs}>
                <div className={styles.searchContainer}>
                  <svg className={styles.searchIcon} width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                  <SearchInput value={searchTerm} onChange={setSearchTerm} className={styles.searchInput} />
                </div>
        </nav>
        <div>
          <PatientsTable 
            patients={filteredPatients} 
            onPatientClick={handlePatientClick} 
          />
        </div>
      </main>
    </div>
  );
};

export default Enproduction;
